import SSOClient from '@kuailu/sso'

/**
 * @殷实
 * 这里是读不到语言文件，连接超时时候的报错， 这里的文案是写死在项目里的。
 * 中文语言下显示中文，其他语言下都显示英文。
 * 所以就不用给繁体了。
 * @param code
 * @param message
 * @returns
 */
export function resolveResError(code?: string, message?: string) {
  switch (code) {
    case '401':
      message = '登录已过期，请重新登录'
      break
    case '403':
      message = '请求被拒绝'
      break
    case '404':
      message = '请求资源或接口不存在'
      break
    case '500':
      message = '服务器发生异常'
      break
    default:
      message = ['zh-CN', 'zh-HK'].includes(SSOClient.currentLocale)
        ? '连接超时，请检查网络连接并重试'
        : 'Connection timed out. Check your network and try again.'
      break
  }
  return message
}

const NEED_MOCK_API_URLS = (import.meta.env.VITE_NEED_MOCK_API_URLS?.split(',') || []).filter(
  Boolean
)

export function isNeedMock(path: string) {
  return NEED_MOCK_API_URLS.some((regStr: string) => {
    const pattern = regStr
    const reg = new RegExp(pattern)
    return reg.test(path)
  })
}
